import React, { ReactNode, useEffect, useRef } from 'react';
import styles from './styles.module.scss';
import CloseBig from '@/assets/svg/closeBig.svg';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { ActionButton } from '@/ui-kit/ActionButton';

interface ModalProps {
  onClose?: () => void;
  children: ReactNode;
  width: string;
  mainStyle?: string;
  modalStyle?: string;
  hideCloseIcon?: boolean;
}

const rootModal = document.getElementById('root-modal') as HTMLElement;

const BaseModal: React.FC<ModalProps> = ({ onClose, children, width, mainStyle, modalStyle, hideCloseIcon }) => {
  const modalOverlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab' && modalOverlayRef.current && !modalOverlayRef.current.contains(e.target as Node)) {
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add('hideScroolling');
    document.getElementById('header')?.classList.add('pr-1.5');
    return () => {
      document.body.classList.remove('hideScroolling');
      document.getElementById('header')?.classList.remove('pr-1.5');
    };
  }, []);

  return ReactDOM.createPortal(
    <>
      <button className={clsx(styles.modalOverlay, mainStyle)} onClick={() => onClose?.()} />
      <div
        className={clsx(styles.modalContent, modalStyle)}
        style={{ '--dynamic-width': width } as React.CSSProperties}
        ref={modalOverlayRef}
        id='baseModal'
      >
        {!hideCloseIcon && (
          <ActionButton
            icon={CloseBig}
            id='CloseModalWindowButton'
            onClick={onClose}
            buttonStyles='float-right mt-5 mr-6 max-sm:mt-2 max-sm:mr-2'
            iconStyles='!w-10 !h-10'
          />
        )}
        <div>{children}</div>
      </div>
    </>,
    rootModal
  );
};

export default BaseModal;
